import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Linkedin = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M19.094 21.416h-14a2 2 0 0 1-2-2v-14a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2m-3.171-2.5h2.67v-5.487c0-2.322-1.315-3.444-3.154-3.444s-2.613 1.432-2.613 1.432v-1.168h-2.574v8.667h2.574v-4.55c0-1.218.561-1.944 1.635-1.944.988 0 1.462.697 1.462 1.944zm-10.33-11.4c0 .882.711 1.599 1.588 1.599s1.587-.717 1.587-1.6-.71-1.599-1.587-1.599-1.587.716-1.587 1.6m2.943 11.4H5.852v-8.667h2.684z'
        fill='currentColor'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M19.094 21.416h-14a2 2 0 0 1-2-2v-14a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2m-3.171-2.5h2.67v-5.487c0-2.322-1.315-3.444-3.154-3.444s-2.613 1.432-2.613 1.432v-1.168h-2.574v8.667h2.574v-4.55c0-1.218.561-1.944 1.635-1.944.988 0 1.462.697 1.462 1.944zm-10.33-11.4c0 .882.711 1.599 1.588 1.599s1.587-.717 1.587-1.6-.71-1.599-1.587-1.599-1.587.716-1.587 1.6m2.943 11.4H5.852v-8.667h2.684z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
